module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proxyValue),
      expression: "proxyValue"
    }],
    staticClass: "form-inline",
    attrs: {
      "type": "checkbox",
      "id": _vm.getName,
      "name": _vm.getName
    },
    domProps: {
      "checked": Array.isArray(_vm.proxyValue) ? _vm._i(_vm.proxyValue, null) > -1 : (_vm.proxyValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.proxyValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.proxyValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.proxyValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.proxyValue = $$c
        }
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43e940d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/CheckboxInputColumnComponent.vue
// module id = 1278
// module chunks = 2